import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatOptions } from '@app/core/components/chat/chat.component';
import { OrderDialogItem, OrderDialogParams } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-dialog-dialog',
    templateUrl: './order-dialog-dialog.component.html',
    styleUrls: ['./order-dialog-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderDialogDialogComponent {
    public chatOptions: ChatOptions<OrderDialogItem>;

    constructor(public dialog: MatDialogRef<OrderDialogDialogComponent>, @Inject(MAT_DIALOG_DATA) data: OrderDialogParams) {
        this.chatOptions = {
            keynames: { commentKeyno: 'reg_datetime' },
            fetch: {
                get: { method: 1281, parameters: { order_internal_no: data.order_internal_no } },
                save: { method: 1280, parameters: { order_internal_no: data.order_internal_no, is_base64: '1' } },
            },
        };
    }
}
